export const underscorize = s => s.split(' ').join('_').toLowerCase()

export const cssVar = v => getComputedStyle(document.documentElement).getPropertyValue(v)

export const isBrowser = () => typeof window !== 'undefined'